<template>
  <div>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="true" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      <el-form-item label="院校名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="formData.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="LOGO" prop="logo_id" :label-width="formLabelWidth">
        <div class="img-item">
          <div class="addimg-select" @click="openUpload(1000)" v-if="!formData.logo"><i class="el-icon-plus"></i></div>
          <el-image class="imgw100" v-else :src="formData.logo" fit="cover" alt="" :preview-src-list="[formData.logo]" />
          <a v-if="formData.logo" href="javascript:void(0);" class="delete-btn" @click.stop="delImg"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">建议尺寸150x150px</p>
      </el-form-item>
      <el-form-item label="地区(省/市)" prop="city_id" :rules="[{required: true,message: '请选择地区'}]" :label-width="formLabelWidth">
        <el-select v-model="formData.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="formData.province_id!=''" v-model="formData.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[formData.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="院校简介" prop="intro" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="formData.intro" :rows="5" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="公众号连接" prop="wx_url" :label-width="formLabelWidth">
        <el-input v-model="formData.wx_url" placeholder="请输入" type="text"></el-input>
      </el-form-item>

      <!--排序-->
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model="formData.sort" placeholder="请输入排序" type="number"></el-input>
      </el-form-item>

      <!--是否热门-->
      <el-form-item label="是否热门推荐" prop="is_hot" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_hot">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-collapse v-model="collapseIndex" @change="collapseChange">
        <el-collapse-item name="1">
          <template slot="title">
            <span class="red">以下为自定义内容 (展开填写)</span>
          </template>
          <div v-if="selectModel.custom_field.length > 0">
            <div v-for="(v, i) in selectModel.custom_field" :key="i">
              <el-form-item :label="v.name" :prop="v.key_name" :label-width="formLabelWidth">
                <el-input v-model="v.content" placeholder="请输入" v-if="v.input_type == 1"></el-input>
                <el-input type="textarea" v-model="v.content" :rows="5" placeholder="请输入" v-else-if="v.input_type == 2"></el-input>
                
                <el-radio-group v-model="v.content" v-else-if="v.input_type == 3">
                  <el-radio :label="vv.value" v-for="(vv, ii) in v.input_values" :key="ii">{{ vv.text }}</el-radio>
                </el-radio-group>
                
                <el-checkbox-group v-model="v.content" v-else-if="v.input_type == 4">
                  <el-checkbox v-for="(vv, ii) in v.input_values" :key="ii" :label="vv.value" >{{vv.text}}</el-checkbox>
                </el-checkbox-group>

                <div v-else-if="v.input_type == 6">
                  <el-input v-model="v.content" placeholder="请输入">
                    <el-button slot="append" @click="openLink(i)">超链接</el-button>
                  </el-input>
                </div>

              </el-form-item>
              <el-form-item label="图片" :label-width="formLabelWidth" v-if="v.input_type == 1 || v.input_type == 2">
                <div class="img-item">
                  <div class="addimg-select" @click="openUpload(i)" v-if="!v.image"><i class="el-icon-plus"></i></div>
                  <el-image class="imgw100" v-else :src="v.image" fit="cover" alt="" :preview-src-list="[v.image]" />
                  <a v-if="v.image" href="javascript:void(0);" class="delete-btn" @click.stop="delImgs(i)"><i class="el-icon-close"></i></a>
                </div>
                <p class="gray9">尺寸宽度750px，高度自适应</p>
              </el-form-item>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>

    
  </el-dialog>
  <!--上传图片组件-->
  <Upload v-if="is_upload" :isupload="is_upload" @returnImgs="returnImgsFunc">上传图片</Upload>
  <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset"></Setlink>
  </div>
</template>

<script>
import SchoolApi from '@/api/study/school.js';
import select_region from '@/utils/select.region.js';
import Upload from '@/components/file/Upload';
import Setlink from '@/components/setlink/Setlink';
import { deepClone, alphabet } from '@/utils/base.js';
export default {
  components: {
    Upload,
    Setlink
  },
  data() {
    return {
      /*省市区*/
      areaList: select_region,
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        logo: '',
        logo_id: '',
        province_id: '',
        city_id: '',
        name: '',
        intro: '',
        wx_url: '',
        sort: 100,
        status: 1,
        is_hot: 0,
      },
      /*验证规则*/
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      /*排序*/
      srot: 100,
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*是否上传图片*/
      is_upload: false,
      collapseIndex: [],
      is_linkset: false,
      linkIndex: 0,
    };
  },
  props: {
    open_edit:Boolean,
    customField:Array,
    selectModel:Object,
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.formData=deepClone(this.selectModel);
    // this.formData.logo = this.selectModel.logo ? this.selectModel.logo.file_path : '';
  },
  methods: {
    openLink(i){
      this.linkIndex = i;
      this.is_linkset = true;
    },
    /*获取链接并关闭弹窗*/
    closeLinkset(e){
      this.is_linkset = false;
      this.selectModel.custom_field[this.linkIndex].content = e.url
    },
    collapseChange(val) {},
    /*初始化城市id*/
    initCity() {
      this.formData.city_id = ''
    },

    /*初始化区id*/
    initRegion() {
      this.formData.region_id = ''
    },
    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      params.custom_field = JSON.stringify(self.selectModel.custom_field);
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SchoolApi.edit(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },
    /*上传*/
    openUpload(e) {
      this.img_index = e;
      this.is_upload = true;
    },

    delImg(){
      this.formData.logo = '';
      this.formData.logo_id = '';
    },

    delImgs(index){
      this.selectModel.custom_field[index].image = '';
      this.selectModel.custom_field[index].image_id = '';
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        if (this.img_index == 1000){
          this.formData.logo = e[0].file_path;
          this.formData.logo_id = e[0].file_id;
        }else{
          this.selectModel.custom_field[this.img_index].image = e[0].file_path;
          this.selectModel.custom_field[this.img_index].image_id = e[0].file_id;
        }
      }
      this.is_upload = false;
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/school/part/Edit.vue